export default "__VITE_ASSET__sdqj71hn__"